import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Bars3Icon, XMarkIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import IsnartechLogo from '../assets/newlogoisnar.png'; // Update path as needed

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isLoginDropdownOpen, setLoginDropdownOpen] = useState(false);

  const navigate = useNavigate();

  const handleNavigateLogin = (userType) => {
    if (userType === 'admin') {
      navigate('/adminstratorLogin');
    } else {
      navigate('/loginPage');
    }
    setLoginDropdownOpen(false);
    setMobileMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur bg-gradient-to-r from-[#1f2937]/90 via-[#0f172a]/90 to-[#1f2937]/90 border-b border-slate-700 shadow-md">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 text-white">

          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <img src={IsnartechLogo} alt="Isnartech Logo" className="w-28 h-auto invert" />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8 items-center">
            <Link to="/" className="hover:text-indigo-400 transition">Home</Link>
            <Link to="/about" className="hover:text-indigo-400 transition">About Us</Link>
            <Link to="/contactForm" className="hover:text-indigo-400 transition">Contact</Link>
            <Link to="/facility" className="hover:text-indigo-400 transition">Facility</Link>

            {/* Login Dropdown
            <div className="relative">
              <button
                onClick={() => setLoginDropdownOpen(!isLoginDropdownOpen)}
                className="flex items-center gap-1 hover:text-indigo-400 transition"
              >
                Login
                <ChevronDownIcon className="h-4 w-4" />
              </button>

              {isLoginDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white text-gray-900 rounded-md shadow-lg z-50">
                  <button
                    className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                    onClick={() => handleNavigateLogin('user')}
                  >
                    Login as User
                  </button>
                  <button
                    className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                    onClick={() => handleNavigateLogin('admin')}
                  >
                    Login as Administrator
                  </button>
                </div>
              )}
            </div>
           */}
          </div>
          {/* Mobile Toggle Button */}
          <div className="md:hidden flex items-center">
            <button onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}>
              {isMobileMenuOpen ? (
                <XMarkIcon className="h-6 w-6" />
              ) : (
                <Bars3Icon className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden px-4 pb-4">
          <Link to="/" className="block py-2 hover:text-indigo-400" onClick={() => setMobileMenuOpen(false)}>Home</Link>
          <Link to="/about" className="block py-2 hover:text-indigo-400" onClick={() => setMobileMenuOpen(false)}>About Us</Link>
          <Link to="/contactForm" className="block py-2 hover:text-indigo-400" onClick={() => setMobileMenuOpen(false)}>Contact</Link>
          <Link to="/facility" className="block py-2 hover:text-indigo-400" onClick={() => setMobileMenuOpen(false)}>Facility</Link>

          {/* Mobile Login Dropdown */}
          <div className="mt-2">
            <button
              onClick={() => setLoginDropdownOpen(!isLoginDropdownOpen)}
              className="flex items-center gap-1 hover:text-indigo-400 w-full"
            >
              Login
              <ChevronDownIcon className="h-4 w-4" />
            </button>
            {isLoginDropdownOpen && (
              <div className="mt-2 ml-4 space-y-1">
                <button
                  className="block text-left text-white hover:text-indigo-300"
                  onClick={() => handleNavigateLogin('user')}
                >
                  Login as User
                </button>
                <button
                  className="block text-left text-white hover:text-indigo-300"
                  onClick={() => handleNavigateLogin('admin')}
                >
                  Login as Administrator
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
